// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2LUSe","additionalInfo":"AgreementModal_additionalInfo__1ysdr"};